import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const appsButtonEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-issue-navigator-actions-pluggable-items-entrypoint" */ './main-new'
			),
	),
	getPreloadProps: () => ({}),
});
